export default function init() {
  if (document.querySelector(".side-nav__toggle")) {
    document.querySelector(".side-nav__toggle").addEventListener("click", e => {
      e.currentTarget.classList.toggle("side-nav__toggle--expanded")
      document.getElementById("side-navigation").classList.toggle("side-nav__nav--open")
    })
  }
}
